import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}roots/api/v1/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const rootsApi = {
  getCompany: (request) => {
    const { pageId } = request
    return instance().get(`/${pageId}/dashboard/company-info`)
  },
  postImportCompany: (request) => {
    const { data } = request
    return instance().post(`/${config.pageId}/dashboard/import`, data)
  },
  postCreateCompany: (request) => {
    const { data, pageId } = request
    return instance().post(`/${pageId}/dashboard/create-company`, data)
  },
  putUpdateCompany: (request) => {
    const { data, pageId } = request
    return instance().put(`/${pageId}/dashboard/edit-company`, data)
  },
  deleteCompany: (request) => {
    const { config, pageId } = request
    return instance().delete(`/${pageId}/dashboard/delete-company`, {
      params: config
    })
  },
  getCompanyWithBranch: (request) => {
    const { config, pageId } = request
    return instance().get(`/${pageId}/dashboard/company-branch-info`, {
      params: config
    })
  },
  postCreateBranch: (request) => {
    const { data, pageId } = request
    return instance().post(`/${pageId}/dashboard/create-branch`, data)
  },
  putUpdateBranch: (request) => {
    const { data, pageId } = request
    return instance().put(`/${pageId}/dashboard/edit-branch`, data)
  },
  deleteBranch: (request) => {
    const { config, pageId } = request
    return instance().delete(`/${pageId}/dashboard/delete-branch`, {
      params: config
    })
  }
}
export default rootsApi



// WEBPACK FOOTER //
// ./src/api/roots.js